import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { range } from 'src/app/utils/lists';

type TProgramEvaluationProblem =
  | 'rewards'
  | 'warranty'
  | 'maintenance'
  | 'other'
  | '';

export type TProgramEvaluationData = {
  programProblem: TProgramEvaluationProblem;
  recommendLevel: number;
  feedback: string;
};

@Component({
  selector: 'app-delete-request-program-eval-modal',
  templateUrl: './delete-request-program-eval-modal.component.html',
  styleUrls: ['./delete-request-program-eval-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Program evaluation form for delete request
 */
export class DeleteRequestProgramEvalModalComponent implements OnInit {
  labels = {
    programEvaluation: 'program-evaluation',
    sendAccountDeleteRequest: 'send-account-delete-request',
    cancel: 'cancel',
    rewards: 'rewards',
    warranty: 'warranty',
    other: 'other',
    maintenance: 'maintenance',
    doYouHaveProblemWithProgram: 'do-you-have-problem-with-program',
    bad: 'bad',
    best: 'best',
    howMuchRecommend: 'how-much-recommend-loyalty-program',
    tellWhatHappened: 'would-you-like-tell-what-happened',
    optionalExplanation: 'your-explanation-is-optional',
  };
  form = new FormGroup({
    programProblem: new FormControl<TProgramEvaluationProblem>(
      '',
      Validators.required
    ),
    recommendLevel: new FormControl<number | undefined>(
      undefined,
      Validators.required
    ),
    feedback: new FormControl<string>(''),
  });
  loading = false;

  /**
   * @constructor
   */
  constructor(
    private readonly translationService: TranslationService,
    private dialogRef: MatDialogRef<DeleteRequestProgramEvalModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TProgramEvaluationData
  ) {}

  /**
   * on init
   */
  ngOnInit() {
    this.translationService.translateObject(this.labels);
    this.form.setValue(this.data);
  }

  /**
   * Close modal
   */
  closeClick() {
    this.data.feedback = this.form.value.feedback || '';
    this.data.programProblem = this.form.value.programProblem || '';
    this.data.recommendLevel = this.form.value.recommendLevel || 0;
    this.dialogRef.close(false);
  }

  /**
   * Sends a request to delete this account
   */
  sendDeleteRequest() {
    this.dialogRef.close(true);
  }

  /**
   * Gets program problem form control from form group
   */
  get programProblemControl() {
    return this.form.controls['programProblem'];
  }

  /**
   * Gets recommend range, a list of 1 to 10
   */
  get recommendRange() {
    return range(10).map((n) => n + 1);
  }

  /**
   * If n is current recommend level
   * @param {number} n
   * @return {boolean}
   */
  isActiveRecommendLevel(n: number): boolean {
    return this.form.controls['recommendLevel'].value === n;
  }

  /**
   * Sets recommendation level
   * @param {number} n
   */
  setRecommendLevel(n: number) {
    if (n < 1 || n > 10) {
      throw new Error('invalid recommend level');
    }
    this.form.controls['recommendLevel'].setValue(n);
  }

  /**
   * Gets feedback form control from form group
   */
  get feedbackControl() {
    return this.form.controls['feedback'];
  }
}
